export const APP_MODE = {
  PAGE: 'PAGE',
  WIDGET: 'WIDGET',
}
